import makeValidationSchema from './PackagingMakeValidationSchema'
import { useTranslation } from 'cng-web-lib'
import React, { useEffect, useState, useContext, useCallback } from 'react'
import Namespace from 'src/constants/locale/Namespace'
import FdapnKeys from 'src/constants/locale/key/Fdapn'
import { Card, CardContent, Grid } from '@material-ui/core'
import { FdaPNTranslationContext } from './../contexts/FDAPNTranslationContext.js'
import { useFormContext, useWatch } from 'react-hook-form';
import {
  components,
} from 'cng-web-lib'

const {
  card: {
    CngSimpleCardHeader,
  },
  form: {
    field: {
      CngSelectField,
      CngTextField,
      CngUomAutocompleteField
    },
  },
  CngGridItem,
} = components

const DEFAULT_INITIAL_VALUES = Object.freeze({
  _id: 0,
  _containerInfoId: 0,
  version: "",
  containerNumber: "",
})

const FORMIK_PROPS = {
  initialValues: { ...DEFAULT_INITIAL_VALUES },
  makeValidationSchema: makeValidationSchema
}

function Fields({
  disabled,
  showNotification,
  parentIdDropdownItems,
  shouldHideMap,
  index
}) {
  const { translate } = useTranslation(Namespace.FDAPN)
  const { getTranslatedText } = useContext(FdaPNTranslationContext)
  const { getValues, setValue, reset, trigger } = useFormContext();

  const { containerNumber } = useWatch()
  console.log("containerNumber: " + JSON.stringify(containerNumber));

  return (
    <Grid container spacing={2}>
      <CngGridItem xs={12} md={12} lg={12} shouldHide={shouldHideMap?.containerNumber}>
        <CngTextField
          name={typeof index === 'number' ? `containerInfo.${index}.containerNumber` : 'containerNumber'}
          label={getTranslatedText('FDAPN', 'containerInfoContainerNumber')}
          onChange={(e) => {
            setValue(typeof index === 'number' ? `containerInfo.${index}.containerNumber` : 'containerNumber', e.target.value.toUpperCase())
          }}
          inputProps={{ maxLength: 20 }}
          size='small'
        />
      </CngGridItem>
    </Grid>
  )
}

const ContainerInfoFormProperties = Object.freeze({
  formikProps: FORMIK_PROPS,
  Fields: Fields
})

export default ContainerInfoFormProperties
